//frontend/src/pages/Home.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useAuthStore } from "../store/authStore"; 

function pickWeighted(items) {
  const total = items.reduce((s, i) => s + i.weight, 0);
  let r = Math.random() * total;
  for (const item of items) {
    if (r < item.weight) return item.value;
    r -= item.weight;
  }
  return items[0].value;
}

export default function Home({ onStart }) {
  const [text, setText] = useState("");
  const { user } = useAuthStore();
  const userName = user?.user_metadata?.full_name ? ((n) => n[0].length <= 20 ? n[0] : n[n.length-1].length <= 20 ? n[n.length-1] : n[0].slice(0,10)+ " " + n[n.length-1].slice(0,10))(user.user_metadata.full_name.trim().split(' ')) : null;
  const userTitle = useMemo(
    () =>
      pickWeighted([
        { value: "Seeker of Insight", weight: 40 },
        { value: "Warden of Curiosity", weight: 25 },
        { value: "Bearer of Questions", weight: 20 },
        { value: "Apprentice of Gnosis", weight: 15 },
      ]),
    []
  );

  const gnosisPersona = useMemo(
    () =>
      pickWeighted([
        { value: "Elarion, Druid of the Verdant Code", weight: 10 },
        { value: "Maelis, Archivist of Silent Circuits", weight: 10 },
        { value: "Thorne, Warden of Forgotten Specs", weight: 10 },
        { value: "Lyra, Oracle of the Copper Grove", weight: 10 },
        { value: "Kael, Runekeeper of Machines", weight: 10 },
        { value: "Seraphae, Priestess of Gnosis", weight: 10 },
        { value: "Virex, Blade of Practical Wisdom", weight: 10 },
        { value: "Orryn, Monk of Measured Choices", weight: 10 },
        { value: "Nyx, Shadow Scholar of Value", weight: 10 },
        { value: "Aethros, Voice of the Old Benchmarks", weight: 10 },
      ]),
    []
  );
  const finalGreeting = userName 
    ? `Greetings, ${userName}, ${userTitle}` 
    : `Greetings, ${userTitle}`;
  const examples = [
    "I need a gaming laptop under $1500 with RTX graphics",
    "Best lightweight laptop for programming and battery life",
    "Laptop for machine learning with strong GPU under $2500",
    "Cheap but reliable laptop for college and daily use",
  ];

  function handleStart() {
    const content =
      text.trim() || "Recommend the best laptop for my needs";
    onStart(content);
    setText("");
  }

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-top px-4 py-12">
       <h1 className="text-4xl md:text-5xl font-dunhill text-center font-bold text-[#394A3C] animate-ink">
             {finalGreeting}
            </h1>

      <div className="w-full max-w-4xl">
        {/* Chat Card */}
        <div className="rounded-2xl ">
          


          {/* Input Area */}
          <div className="px-6 py-5">
            <p className="mt-4 text-sm italic text-[#6F9075] m-3 pt-1">
               <span className="text-emerald-700">My name is {gnosisPersona}</span>
            </p>
            <div className="relative">
              <textarea
                rows={4}
                className="w-full resize-none rounded-xl bg-[#2F2D28] border border-[#7A8065] px-4 py-3 pr-14 text-[#ECE7D5] placeholder-[#B8B2A1] focus:outline-none focus:ring-2 focus:ring-[#8FB996] overflow-y-auto min-h-[144px] max-h-[224px]"
                style={{ height: "auto" }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
                // --- YENİ EKLENEN KISIM ---
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault(); 
                    handleStart();      
                  }
                }}
                // -------------------------
                placeholder="Describe the laptop you seek — budget, performance, purpose..."
                value={text}
                onChange={(e) => setText(e.target.value)}
              />

              <button
                onClick={handleStart}
                className="absolute bottom-3 right-3 rounded-lg bg-[#6FA58E] hover:bg-[#7FBFA3] text-[#1F2A24] px-3 py-1.5 text-sm font-medium transition active:scale-95"
                aria-label="Get recommendation"
              >
                Ask
              </button>
            </div>

            {/* Helper text */}
            <p className="mt-3 text-xs text-stone-400 text-center pt-1">
              Gnosis currently recommends <span className="text-emerald-600">laptops only</span>.
              You’ll receive the best pick. Guranteed (Not guranteed)
            </p>

            {/* Quick Examples */}
            <div className="mt-1 ">
              <p className="text-xs text-stone-400 mb-2">Quick examples</p>
              <div className="flex flex-col items-start gap-2">
                {examples.map((ex, i) => (
                  <button
                    key={i}
                    onClick={() => setText(ex)}
                    className="rounded-full text-left border border-[#B6A875] bg-[#FBF5DE] px-4 py-1.5 text-xs text-[#4A4438] hover:bg-[#EFE4C2] transition"
                  >
                    {ex}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer flavor */}
        <p className="mt-6 text-center text-xs text-stone-500">
          Gnosis weighs wisdom, price, and performance — so you don’t have to.
        </p>
      </div>
    </div>
  );
}
